module.exports = __webpack_public_path__ + "img/service-4.c90a83f9.svg";